import { render, staticRenderFns } from "./userDepartmentSelection.vue?vue&type=template&id=2529f525&scoped=true&"
import script from "./userDepartmentSelection.vue?vue&type=script&lang=js&"
export * from "./userDepartmentSelection.vue?vue&type=script&lang=js&"
import style0 from "./userDepartmentSelection.vue?vue&type=style&index=0&id=2529f525&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2529f525",
  null
  
)

export default component.exports